import { BillingPlanKind } from 'src/lib/graphqlTypes/types';

/**
 * Returns a formatted name for a billing plan, or null if the badge should not be rendered.
 *
 * @param {string} planName - The original name of the billing plan.
 * @param {string} planKind - The kind of the billing plan (e.g., ENTERPRISE_TRIAL).
 */
export const getPlanBadgeProperties = (
  planName?: string,
  planKind?: BillingPlanKind,
): { label: string; tooltip?: string; isInteractive: boolean } | null => {
  if (!planName || !planKind) return null;

  switch (planKind) {
    case BillingPlanKind.ENTERPRISE_TRIAL:
      return {
        label:
          planName === 'Apollo Enterprise Self-Serve Trial'
            ? 'Enterprise Trial'
            : planName,
        isInteractive: false,
      };

    case BillingPlanKind.FREE:
    case BillingPlanKind.PLACEHOLDER_FREE:
      return {
        label: planName,
        tooltip: 'Unlock more features',
        isInteractive: true,
      };

    case BillingPlanKind.SCALE:
      return {
        label: 'Scale',
        tooltip: 'Unlock more features',
        isInteractive: true,
      };

    // TODO(Scale): These enums will change
    case BillingPlanKind.SCALE_BASIC:
    case BillingPlanKind.DEVELOPER:
      return {
        label: 'Developer',
        tooltip: 'Unlock more features',
        isInteractive: true,
      };

    case BillingPlanKind.SCALE_ADVANCED:
    case BillingPlanKind.STANDARD_SALES_ASSISTED:
    case BillingPlanKind.STANDARD_SELF_SERVICE:
      return {
        label: 'Standard',
        tooltip: 'Unlock more features',
        isInteractive: true,
      };

    default:
      return null;
  }
};
